import { Down as DownArrow, Up as UpArrow } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import { StatusChangeProps } from './types';

const StatusChange = (props: StatusChangeProps) => {
  const { value, isROITile, showPercentage = true } = props;

  const color = value < 0 ? 'var(--color-content-status-danger-secondary)' : 'var(--color-content-status-success-secondary)';
  const iconStyle = { width: '15px', height: '15px', color };
  const icon = value < 0 ? <DownArrow style={iconStyle} /> : <UpArrow style={iconStyle} />;
  const formattedValue = Number.isFinite(value) ? `${value.toFixed(isROITile ? 0 : 2)}${showPercentage ? ' %' : ''}` : 'NA';

  return (
    <Box sx={{ ...flex.itemsCenter }}>
      {icon}
      <Box sx={{ color, fontWeight: 600, fontSize: 13 }}> {formattedValue}</Box>
    </Box>
  );
};

export default StatusChange;
